'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var baseStyleContainer = function baseStyleContainer() {
  return {};
};
var baseStyleLabel = function baseStyleLabel() {
  return {
    color: 'gray.400'
  };
};
var baseStyleValue = function baseStyleValue() {
  return {};
};
var baseStyle = {
  container: baseStyleContainer(),
  label: baseStyleLabel(),
  value: baseStyleValue()
};
var Editable = {
  baseStyle: baseStyle
};
exports["default"] = Editable;